import { Badge } from "@/components/ui/badge"
import { usePageContext } from "../hooks/use-page-context"

export function ContextBadge() {
  const { orderId, projectId } = usePageContext()

  if (orderId) {
    return <Badge variant="secondary">Order #{orderId}</Badge>
  }
  if (projectId) {
    return <Badge variant="secondary">Project #{projectId}</Badge>
  }
  return null
}
